import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PageLayout } from './components/PageLayout';
import { Home } from './pages/Home';
import { ElectroPlating } from './pages/ElectroPlating';
import { ElectroPlatingRF } from './pages/ElectroPlatingRF';
import { SurfactantOptimization } from './pages/SurfactantOptimization';
import './styles/App.css';

const Pages = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/electro-plating" element={<ElectroPlating />} />
            <Route path="/electro-plating-rf" element={<ElectroPlatingRF />} />
            <Route path="/surfactant-optimization" element={<SurfactantOptimization />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

const App = ({ instance }) => {
    return (
        <MsalProvider instance={instance}>
            <Router>
                <PageLayout>
                    <Pages />
                </PageLayout>
            </Router>
        </MsalProvider>
    );
};

export default App;